import React from 'react';
import { UrgencyTimer } from './components/UrgencyTimer';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { FeatureGrid } from './components/FeatureGrid';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { TransformationBlock } from './components/TransformationBlock';
import { TransformationQuote } from './components/TransformationQuote';
import { Testimonials } from './components/Testimonials';
import { BonusBundle } from './components/BonusBundle';
import { PricingFAQ } from './components/PricingFAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-charcoal text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <UrgencyTimer data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <FeatureGrid data-id="element-6" />
        <WhoIsThisFor data-id="element-7" />
        <TransformationBlock data-id="element-8" />
        <TransformationQuote data-id="element-9" />
        <Testimonials data-id="element-10" />
        <BonusBundle data-id="element-11" />
        <PricingFAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}